import React, { useEffect } from 'react'
import { useState } from 'react'
import "./Header.css"
import { Link, useNavigate } from 'react-router-dom'
import { Modal } from 'antd';
import { useUserActions } from '../../pages/Users/connectApi/users';

function Header() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { getUserById } = useUserActions((state) => state.actions)
    const admin = useUserActions((state) => state.admin);
    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    const navigate = useNavigate()

    const logOut = () => {
        localStorage.clear()
        navigate("/")
    }
    
    useEffect(() => {
        getUserById(Number(localStorage.getItem("pelakUserId")))
    }, [])

    
    return (
        <div className='z-40 p-2 w-full sticky top-0 border-b-2 shadow-[0px_0px_7px_0px_#00000080] bg-[#F4F4F4] mb-8 flex items-center justify-around'>
            {/* <Link to={'/automation'} className='flex items-center justify-center gap-4 bg-white p-2 rounded'>
                <p>اتوماسیون اداری</p>
                <img src="/icons/office.svg" alt="اتوماسیون اداری" />
            </Link> */}
            <div className='relative'>
                <div onClick={showModal} className='flex items-center justify-center gap-4 cursor-pointer'>
                    <img src="/icons/user.svg" alt="کاربر" />
                    <p>{admin && admin.firstName} {admin && admin.lastName}</p>
                    <img src="/icons/arrow-down.svg" alt="اطلاعات بیشتر" />
                </div>
                <Modal title="پروفایل کاربری" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={false}>
                    <div className='fade-in-h text-sm py-6 flex flex-col gap-6 px-2 w-full  h-auto bg-white  top-8  mt-4 z-40 '>
                        <Link onClick={handleCancel} to={"/TeammateProfileDetails"}
                            className='flex items-center justify-between transition-all hover:bg-gray-200 p-2 rounded'>
                            <span>پروفایل</span>
                            <img src="/icons/arrow-down.svg" alt="اطلاعات بیشتر" className='rotate-90' />
                        </Link>
                        <Link onClick={handleCancel} className='flex items-center justify-between transition-all hover:bg-gray-200 p-2 rounded'
                            to={'/ChangePassword'}>
                            <span>تغییر رمز عبور</span>
                            <img src="/icons/arrow-down.svg" alt="اطلاعات بیشتر" className='rotate-90' />
                        </Link>
                        <div className='flex items-center justify-between cursor-pointer transition-all hover:bg-gray-200 p-2 rounded' onClick={() => logOut()}>
                            <span>خروج از حساب کاربری</span>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15M12 9l-3 3m0 0 3 3m-3-3h12.75" />
                            </svg>
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    )
}

export default Header